'use strict';

var $ = require('jquery');

// Constructor
var Actuation = function() {

};

Actuation.init = function () {
    if (!$('body#scan').length) {
        return true;
    }

    $('.actuation .actuation__switch input').on('change', function() {
        var dynamicValue = $(this).parent().parent().parent().find('span.value');
        if ($(this).is(":checked")) {
            dynamicValue.text('1');
        } else {
            dynamicValue.text('0');
        }
    });

    $('.actuation .actuation__plus-minus a').on('click touchstart', function (e) {
        var dynamicValue = $(this).parent().parent().parent().find('span.value');
        var currentValue = parseInt(dynamicValue.text());

        if ($(this).hasClass('plus')) {
            dynamicValue.text(parseInt(currentValue + 1000));
        } else {
            if (currentValue <= 1000) {
                currentValue = 0;
                dynamicValue.text('0');
                return true;
            }
            dynamicValue.text(parseInt(currentValue - 1000));
        }
    });

    var extraFunctionBtns = $('.actuation__function-btn a');
    extraFunctionBtns.on('click touchstart', function (e) {
        var variables = {};
        variables.link = $(this);
        variables.link.addClass('effect');
        variables.removeClass = setTimeout(function () {
            variables.link.removeClass('effect');
        }, 500);
    });

    extraFunctionBtns.on('click touchstart', function (e) {
        extraFunctionBtns.removeClass('success');
        extraFunctionBtns.removeClass('error');
        var $this = $(this);
        $this.addClass('loading');
        setTimeout(function() {
            var resultingStatus = Math.random() < 0.8 ? 'success' : 'error';
            $this.removeClass('loading');
            $this.addClass(resultingStatus);
        }, 2000);
    });
};

module.exports = Actuation;
